import {
  Paper,
  ListItem,
  Typography,
  List,
  Box,
  Skeleton,
} from '@mui/material';
import { Comment, getBackgroundColor } from '../../GameTableRow';
import { getRoleName } from '..';
import HttpService from '../../../../hooks/Https-services';
import { API_ROUTES } from '../../../../utils/constant';
import { useCallback, useEffect, useState } from 'react';
import CommentDataList from '../CommentDataList';

const CommentDataTable = ({ data }: { data: any }) => {
  const [comments, setComments] = useState<Comment[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const GetComments = useCallback(async () => {
    try {
      setIsLoading(true);

      const res = await HttpService.get(
        API_ROUTES.getComments.replace(':id', data.gameId)
      );
      if (res.data.data) {
        setComments([...(data.comment || []), ...res.data.data]);
      } else {
        setComments([...(data.comment || [])]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [data?.comment]);
  useEffect(() => {
    GetComments();
    return () => {
      setComments([]);
    };
  }, [GetComments]);

  return (
    <Box>
      <Box sx={{ flexGrow: 1 }}>
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              py: 2,
            }}
          >
            <Skeleton sx={{ py: 4 }} variant="rounded" />
            <Skeleton sx={{ py: 4 }} variant="rounded" />
            <Skeleton sx={{ py: 4 }} variant="rounded" />
          </Box>
        ) : (
          <CommentDataList comments={comments} />
        )}
      </Box>
    </Box>
  );
};
export default CommentDataTable;
